<template>
  <div class="preview-page">
    <div class="preview-page-body">
      <iframe id="iframe" class="match-height match-width" src="https://h5.cdn.bjadks.com/website/lvzhengcaovr/index.html" frameborder="no" />
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    setTimeout(() => {
      const iframe = document.getElementById('iframe')
      if (iframe && iframe.contentWindow) {
        console.log(iframe)
        const iframedoc = iframe.contentWindow.document
        const ads = iframedoc.getElementsByClassName('ads--RPf__')
        console.log(ads)
        if (ads && ads.length > 0) {
          console.log(ads)
          ads[0].style.display = 'none'
        }
      }
    }, 5000)
  }
}
</script>

<style scoped>
  .preview-page-body {
    width: 100%;
    height: 100vh;
  }

  ::deep {
    .ads--RPf__ {
      display: none !important;
    }
  }
</style>
